import React from "react";
import PropTypes from "prop-types";
import { times } from "lodash";
import { PaginationLink, PaginationWrapper } from "./styled";
import BackSteppers from "./BackSteppers";
import ForwardSteppers from "./ForwardSteppers";

function createPaginationLinks(array, currentPage, pathRoot, buffer = 2) {
  // calculate the starting and ending index points
  const startingPosition = currentPage - buffer < 0 ? 0 : currentPage - buffer;
  const endingPosition =
    currentPage === 1 ? currentPage + buffer : currentPage + buffer - 1;
  // slice the array with those index points
  const slicedArray = array.slice(startingPosition, endingPosition);
  // from that sliced array, create elements
  return slicedArray.map(pageItem => (
    <PaginationLink
      key={`pagination-number${pageItem.pageNumber}`}
      to={`${pathRoot}/${pageItem.pageNumber === 1 ? "" : pageItem.pageNumber}`}
      className={currentPage === pageItem.pageNumber ? "current-page" : ""}
    >
      {pageItem.pageNumber}
    </PaginationLink>
  ));
}

const Paginator = props => {
  const { currentPage, numberOfPages, pathRoot } = props;
  const paginationArray = times(numberOfPages, pageNumberValue => ({
    pageNumber: pageNumberValue + 1
  }));
  const paginationLinks = createPaginationLinks(
    paginationArray,
    currentPage,
    pathRoot
  );

  return (
    <PaginationWrapper>
      <BackSteppers {...props} />
      {paginationLinks}
      <ForwardSteppers {...props} />
    </PaginationWrapper>
  );
};

Paginator.propTypes = {
  pathRoot: PropTypes.string,
  currentPage: PropTypes.number,
  numberOfPages: PropTypes.number
};

Paginator.defaultProps = {
  pathRoot: "",
  currentPage: 1,
  numberOfPages: 1
};

export default Paginator;
